<template>
  <div class="details">
    <breadcrumb></breadcrumb>
    <div class="flex-center">
      <div class="content">
          <div class="title">{{data.trainingTitle||''}}</div>
          <div class="time" v-if="data.createTime">发布时间：{{data.createTime}}</div>
          <div v-html="data.content"></div>
          <div class="flex-center button" v-if="data.id">
            <el-button :disabled="data.cartStatus||data.signUpStatus" type="success" @click="toAddCart">加入课程表</el-button>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

import {getTrainingDetails,addCart} from '@/api/course.js'
import breadcrumb from '@/components/breadcrumb.vue'
export default {
  components:{
    breadcrumb
  },
  data(){
      return {
        id:'',
        data:{},
      }
  },
  
  created(){
    this.id=this.$route.query.id
    this.getData()
  },
  methods:{
    getData(){
      getTrainingDetails(this.id).then(res=>{
        if(res.data.code==200){
          this.data=res.data.data
        }
      })
    },
    toAddCart(){
      addCart({
        trainingId: this.id,
        trainingDetail: this.data
      }).then(res=>{
        // console.log(res)
        if(res.data.code==200){
          if(res.data.data){
             this.$message.success('加入课程表成功')
          }else{
            this.$message.error('加入课程表失败，稍后再试')
          }
        }
        // else{
        //   this.$message.error(res.data.msg)
        // }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.details{
  padding:0 10%;
  padding-bottom: 109px;
  padding-top: 26px;
  .content{
    width: 56.25%;
    background: #fff6e8;
    padding:64px;
    margin-top:48px;
    font-size: 20px;
    color: #333333;
    // overflow-y: scroll;
    .title{
      font-size: 28px;
      color: #ed9d26;
      font-weight: bold;
      text-align: center;
    }
    .time{
      font-size: 20px;
      color: #333333;
      margin:32px 0;
      text-align:center;
    }
    .button{
        margin-top:20px;
    }
    ::v-deep {
      img {
        max-width: 100% !important;
        height: auto !important;
        display: block;
        margin: 10px auto;
      }
      table {
        max-width: 100% !important;
        border-collapse: collapse;
        margin: 10px 0;
        overflow-x: auto;
        display: block;
      }
      table td, table th {
        border: 1px solid #ddd;
        padding: 8px;
        word-wrap: break-word;
        word-break: break-all;
      }
      p, div, span {
        max-width: 100%;
        word-wrap: break-word;
        word-break: break-word;
      }
      video, iframe {
        max-width: 100% !important;
        height: auto !important;
      }
      pre {
        max-width: 100%;
        overflow-x: auto;
        word-wrap: break-word;
        word-break: break-all;
      }
      * {
        box-sizing: border-box;
      }
    }
  }
}

// 当前页颜色
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover{
  color: #303133;
  font-weight: 700;
}
::v-deep .el-breadcrumb__inner a,::v-deep .el-breadcrumb__inner.is-link{
  color: #606266;
  font-weight: 400;
}
</style>